import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CommonProfileService,
  ProfileWebModel,
  ProfileRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsVoidType, RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CommonProfileApiService {
  constructor(private apiService: CommonProfileService) {}

  public deleteOwnProfile(requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.profileDelete(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editOwnProfile(body: ProfileRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<ProfileWebModel> {
    return this.apiService.profileEdit(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getOwnProfile(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<ProfileWebModel> {
    return this.apiService.profileGet(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public logout(requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.profileLogout(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
